import { render, staticRenderFns } from "./Minimal.vue?vue&type=template&id=b945f390&scoped=true"
import script from "./Minimal.vue?vue&type=script&lang=js"
export * from "./Minimal.vue?vue&type=script&lang=js"
import style0 from "./Minimal.vue?vue&type=style&index=0&id=b945f390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b945f390",
  null
  
)

export default component.exports